export enum Enumvalues {
  VALUE_1 = '1',
  VALUE_2 = '2',
  VALUE_3 = '3',
  VALUE_4 = '4',
  VALUE_5 = '5'
}
export class PendingUserConstants {
  static readonly SLASH_USER_MANAGEMENT = '/user-mgmt/';
  static readonly USER_MANAGEMENT = 'usermanagment/';
  static readonly SLASH_USER = 'users';
  static readonly SEARCH_QUERY = '?';
  static readonly EQUALS = '=';
  static readonly USER_ID = 'userId';
  static readonly USER_ROLE = 'userRole';
  static readonly RETAILER_ID = 'retailerId';
  static readonly SORT_BY = 'sortby';
  static readonly SORT_TYPE = 'sorttype';
  static readonly STATUS_ACTIVE = '?status';
  static readonly PENDING = 'pending';
  static readonly NAME_SEARCH = 'namesearch';
  static readonly EMAIL_SEARCH = 'emailsearch';
  static readonly RETAILER_VALUE_SEARCH = 'retailernamesearch';
  static readonly COUNTRY_VALUE_SEARCH = 'locationsearch';
  static readonly NAME = $localize`:@@pending-users.users-name-value:Name`;
  static readonly EMAIL = $localize`:@@pending-users.users-email-value:Email`;
  static readonly RETAILER_VALUE = $localize`:@@pending-users.users-retailer-value:Retailer Name`;
  static readonly COUNTRY_VALUE =  $localize`:@@pending-users.users-country-value:Location`;
  static readonly STORE_NAME_SEARCH = 'storenamesearch';
  static readonly STORE_VALUE = $localize`:@@pending-users.users-store-value:Store Name`;
  static readonly STORENAME_SORT = 'storeName';
  static readonly INVITEDBY_SORT = 'createdByName';
  static readonly NAME_SORT = 'name';
  static readonly EMAIL_SORT = 'email';
  static readonly RETAILER_SORT = 'retailerName';
  static readonly COUNTRY_SORT = 'country';
  static readonly COUNTRY_SORTBY = 'location';
  static readonly CREATED_BY_SORT = 'userID';
  static readonly EMPTY_VALUE = '';
  static readonly ASCENDING_ORDER = 'asc';
  static readonly DESCENDING_ORDER = 'desc';
  static readonly AND = '&';
  static readonly RETAIL_USER_ROLE = 'retailHQUser';
  static readonly SLASH_RETAIL = '/retailer';
  static readonly RETAILERID = '?retailerid';
  static readonly SLASH = '/';
  static readonly AND_STATUS = '&status';
  static readonly STOREID = 'storeId';
  static readonly PAGE_NUMBER = '&pagenumber';
  static readonly USER = $localize `:@@pending-users.user:User`;
  static readonly APPROVE =  $localize`:@@pending-users.approve-text:Approve`;
  static readonly REJECT =  $localize`:@@pending-users.reject-text:Reject`;
  static readonly DESCRIPTION = $localize`:@@pending-users.modal-description:This change may apply to all profiles and devices using this information.`;
  static readonly APPROVE_USER = $localize`:@@pending-users.approve-user-text:Approve User`;
  static readonly REJECT_USER = $localize`:@@pending-users.reject-user-text:Reject User`;

  static readonly USERS = $localize `:@@pending-users.users:Users`;
  static readonly APPROVE_USERS = $localize`:@@pending-users.approve-users-text:Approve Users`;
  static readonly REJECT_USERS = $localize`:@@pending-users.reject-users-text:Reject Users`;
}
